<template>
  <AddProductDirectlyBtn
    v-if="bookableDirectly(product)"
    :key="product.ProductId"
    :class="absoluteTopRight ? 'position_top-right' : ''"
    :product="product"
  />

  <v-tooltip v-else bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        fab
        depressed
        v-bind="attrs"
        v-on="on"
        :key="product.ProductId"
        color="primary"
        :class="absoluteTopRight ? 'position_top-right' : ''"
        @click.stop="onInfoBtnClick"
      >
        <v-icon class="primary-font-color" small
          >mdi-information-variant</v-icon
        >
      </v-btn>
    </template>
    <span>{{ $translate('PRODUCT_INFO') }}</span>
  </v-tooltip>
</template>

<script>
import { hasCapacity, bookableDirectly } from '@/objects/Product';
import AddProductDirectlyBtn from '@/components/event/eventDetails/productOrderComponents/AddProductDirectlyBtn';

export default {
  name: 'TrendingProductsButtons',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {},
    },
    absoluteTopRight: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddProductDirectlyBtn,
  },
  methods: {
    bookableDirectly,
    onAddBtnClick() {
      this.$emit('add');
    },
    onInfoBtnClick() {
      this.$emit('info');
    },
  },
};
</script>

<style scoped lang="scss">
.position_top-right {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
